import {Store} from "@ngneat/elf";
import {deleteEntities} from "@ngneat/elf-entities";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ModellHendelseHåndteringBygger} from "felles-ng2/tjenester/datalager/modellHendelseHåndtering/ModellHendelseHåndteringBygger";
import {verifiserErIkkeNil} from "felles-ng2/støttefunksjoner/antakelser";
import {Modelloppdateringer} from "felles-ng2/tjenester/Modelloppdateringer";

const debug = initDebugger('ModellSlettetHendelseHåndtering');

/** Håndtering av modelloppdatering-push meldinger for slett hendelser.
 * Merk at denne som standard sletter fra lager uavhengig om det er registrert abonnenter eller ei.
 * Kall {@link #medAbonnentoppslag} for å aktivere filtering basert på abonnenter. */
export class ModellSlettetHendelseHåndteringBygger<HENDELSE_MODELL_TYPE, ENTITET_TYPE> extends ModellHendelseHåndteringBygger<HENDELSE_MODELL_TYPE, ModellSlettetHendelseHåndteringBygger<HENDELSE_MODELL_TYPE, ENTITET_TYPE>> {

    constructor(datalager: Store, modelloppdateringer: Modelloppdateringer) {
        super(datalager, modelloppdateringer, debug);
        this.medIgnorerAbonnementSjekk();
    }

    // ModellHendelseHåndtering impl

    protected opprettKopi(): ModellSlettetHendelseHåndteringBygger<HENDELSE_MODELL_TYPE, ENTITET_TYPE> {
        return new ModellSlettetHendelseHåndteringBygger<HENDELSE_MODELL_TYPE, ENTITET_TYPE>(this.datalager, this.modelloppdateringer)
          .medEntitetId(this.entitetId);
    }

    protected async oppdaterLager(hendelseModell: HENDELSE_MODELL_TYPE) {
        verifiserErIkkeNil(this.entitetId, 'har du glemt å kalle medEntitetId(..)?');

        const entitetId = this.entitetId(hendelseModell);
        this.debug(`sletter entitet:${entitetId} fra lager`, hendelseModell, entitetId);
        this.datalager.update(deleteEntities(entitetId));
    }
}
